// Потянуть вниз у верхнего края → перезапросить всё, что сейчас на экране (активные запросы TanStack Query).
// Свой жест: вертикальные свайпы Telegram отключены (disableVerticalSwipes), системного pull-to-refresh в webview нет.
import { useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { haptic } from '../telegram/webapp';
import styles from './PullToRefresh.module.css';

const TRIGGER = 72; // px сдвига пальца (после демпфирования), с которого отпускание обновляет
const MAX = 110;

export function PullToRefresh() {
  const queryClient = useQueryClient();
  const [pull, setPull] = useState(0);
  const [busy, setBusy] = useState(false);
  const start = useRef<number | null>(null);
  const armed = useRef(false);

  useEffect(() => {
    const onStart = (e: TouchEvent) => {
      start.current = window.scrollY <= 0 && !busy ? e.touches[0]!.clientY : null;
      armed.current = false;
    };
    const onMove = (e: TouchEvent) => {
      if (start.current === null) return;
      const dy = e.touches[0]!.clientY - start.current;
      if (dy <= 0 || window.scrollY > 0) { setPull(0); return; }
      const next = Math.min(MAX, dy * 0.5);
      if (next >= TRIGGER && !armed.current) { armed.current = true; haptic.impact('light'); }
      if (next < TRIGGER) armed.current = false;
      setPull(next);
    };
    const onEnd = () => {
      if (start.current === null) return;
      start.current = null;
      if (armed.current) {
        setBusy(true);
        setPull(TRIGGER * 0.6);
        void queryClient.refetchQueries({ type: 'active' }).finally(() => { setBusy(false); setPull(0); });
      } else setPull(0);
      armed.current = false;
    };
    window.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onEnd);
    window.addEventListener('touchcancel', onEnd);
    return () => {
      window.removeEventListener('touchstart', onStart);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onEnd);
      window.removeEventListener('touchcancel', onEnd);
    };
  }, [busy, queryClient]);

  if (!pull && !busy) return null;
  const progress = Math.min(1, pull / TRIGGER);
  return (
    <div className={styles.wrap} style={{ transform: `translateY(${pull}px)` }} aria-hidden="true">
      <span className={`${styles.ring} ${busy ? styles.spin : ''}`}
        style={{ opacity: 0.3 + progress * 0.7, transform: busy ? undefined : `rotate(${progress * 270}deg)` }} />
    </div>
  );
}
